var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetWrapper',{staticClass:"app-sheet-contact-additional-details"},[_c('AppContactAdditionalDataRichText',{attrs:{"html-content":_vm.htmlContent,"compact":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }